/**
 * Design tokens, read from the live document.
 *
 * Two callers need this and neither can use `var(--tp-color-*)`: Leaflet writes SVG attributes and
 * canvas options into elements it owns, outside React, and an attribute value cannot be a custom
 * property reference. `PlaceMap` colours its pins this way, `RouteMap` colours its polyline, and the
 * alternative — typing `#2f6f4f` in a component — is the second copy of a palette entry that stops
 * being contrast-checked the moment the palette moves. `styles.test.ts` fails the build on exactly that,
 * which is how the duplication was caught in the first place.
 *
 * Reading at call time rather than caching: a token can change while the page is open (a theme switch, a
 * hot reload during development), and a cached value would be the stale copy this module exists to
 * prevent. `getComputedStyle` on the root element is cheap enough to call when a map redraws.
 */

/** One token's value, e.g. `readToken("--tp-color-accent")`. */
export function readToken(name: string): string {
  if (typeof document === "undefined") return "";
  return getComputedStyle(document.documentElement).getPropertyValue(name).trim();
}
